import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Lightning } from "@phosphor-icons/react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      const next = location.state?.from || "/dashboard";
      navigate(next);
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Lightning size={48} weight="fill" className="text-[#007AFF] mb-6" />
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter leading-none mb-2">
          Project Pulse
        </h1>
        <p className="text-[color:var(--text-secondary)] mt-4 mb-10">
          Sign in to your tactical workspace.
        </p>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="label-mono block mb-2">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              required
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="label-mono block mb-2">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              required
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          {error && (
            <div data-testid="login-error" className="text-sm text-red-400 border border-red-500/30 bg-red-500/10 rounded px-3 py-2">
              {error}
            </div>
          )}
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <p className="text-sm text-[color:var(--text-secondary)] mt-8">
          New here?{" "}
          <Link data-testid="goto-register-link" to="/register" className="text-[#007AFF] hover:underline font-semibold">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
